import React, { useState } from 'react';
import MonsterLineup from './MonsterLineup';
import GymEventList from './GymEventList';
import BadgeSelector from './BadgeSelector';
import { useSettings } from '../context/SettingsContext';
import { logInfo, logError } from '../utils/logger';

const GymPopup = ({ gym, monsters, events, onClose, onBadgeUpdate, onTimeSpanChange }) => {
  const { eventTimeSpan, setEventTimeSpan, availableTimeSpans } = useSettings();
  const [selectedTab, setSelectedTab] = useState('monsters');
  
  const handleTabChange = (newTab) => {
    //logInfo("Tab changed to:", newTab);
    setSelectedTab(newTab);
	
	if (newTab !== 'monsters') {
      const e = {
        target: {
          value: eventTimeSpan
      }}
      handleTimeSpanChange(e);
	}
  };

  const handleBadgeChange = (badgeLevel) => {
    onBadgeUpdate(gym.id, badgeLevel);
  };

  const handleTimeSpanChange = (e) => {
    //logInfo("e changed to:", e);
    const newTimeSpan = e.target.value;
    setEventTimeSpan(newTimeSpan);
    onTimeSpanChange(newTimeSpan);
  };
  
  //logInfo('badge_level', gym.badge_level)

  return (
    <div className="gym-popup-overlay" onClick={onClose}>
      <div className="gym-popup" onClick={(e) => e.stopPropagation()}>
        <div className="gym-popup-header">
          <h3>{gym.name}</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="gym-popup-badge">
          <BadgeSelector
            currentBadge={gym.badge_level || 0}
            onChange={handleBadgeChange}
          />
        </div>
        
        <div className="gym-popup-content">
          <div className="gym-popup-tabs">
            <button
              className={selectedTab === 'monsters' ? 'active' : ''}
              onClick={() => handleTabChange('monsters')}
            >
              Monsters
            </button>
            <button
              className={selectedTab === 'events' ? 'active' : ''}
              onClick={() => handleTabChange('events')}
            >
              Events
            </button>
          </div>
          
          {selectedTab === 'monsters' ? (
            <MonsterLineup gym={gym} monsters={monsters} />
          ) : (
            <>
              <div className="time-span-selector">
                <label htmlFor="timeSpan">Time Span:</label>
                <select
                  id="timeSpan"
                  value={eventTimeSpan}
                  onChange={handleTimeSpanChange}
                >
                  {availableTimeSpans.map((span) => (
                    <option key={span} value={span}>
                      {span}
                    </option>
                  ))}
                </select>
              </div>
              <GymEventList events={events} />
            </>
          )}
        </div>
        
        <div className="gym-popup-footer">
          <div className="gym-stats">
            <div className="stat">
              <span className="label">Total CP:</span>
              <span className="value">{gym.total_cp}</span>
            </div>
            <div className="stat">
              <span className="label">Available Slots:</span>
              <span className="value">{gym.slots_available}</span>
            </div>
            <div className="stat">
              <span className="label">In Battle:</span>
              <span className="value">{gym.in_battle ? 'Yes' : 'No'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GymPopup;